/*
 * Полоса хода генерации в шапке. Своих цветов здесь нет ни одного: фиолетовый берётся
 * токенами (--violet, --violet-bg, --violet-light), отказ — красным токеном текста
 * (docs/ui-design.md §9, запрет на хардкод фирменного цвета).
 *
 * ПРАВИЛО ОДНОГО АКЦЕНТА НЕ НАРУШЕНО, ХОТЯ РЯДОМ ФИОЛЕТОВАЯ КНОПКА. Акцент — заливка;
 * полоса высотой 4px на светлой дорожке — это индикатор, а не орган: нажимать в ней нечего,
 * и по весу пятна она заведомо легче кнопки. Разделитель шапки при этом остаётся между
 * переключателем режима и этой парой: полоса относится к действию, а не к состоянию канала.
 *
 * ШИРИНА ФИКСИРОВАННАЯ, А НЕ ПО СОДЕРЖИМОМУ. Подпись меняется на каждом этапе («тема» →
 * «гейт живого текста»), и орган, дышащий шириной раз в секунду, дёргал бы всю правую
 * группу шапки. Поэтому ширина задана, а текст сжимается многоточием.
 */

.wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 232px;
  flex: none;
  min-width: 0;
}

.head {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: none;
  max-width: 100%;
}

a.link {
  color: var(--accent-ink);
  text-decoration: none;
}
a.link:hover {
  text-decoration: underline;
}

/* Деталь шага — то, что сервис сказал о себе своими словами: формат, черновик, правило
   гейта. Она уступает подпись этапа и гаснет первой, поэтому ей и достаётся сжатие. */
.detail {
  font-size: 11.5px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* Отказ — единственное состояние, где текст красный: полоса остаётся фиолетовой, потому
   что она отвечает на «сколько прошли», а не на «чем кончилось». */
.bad {
  color: var(--red-ink);
}

/*
 * «+N» — сколько прогонов ждёт за показанным (правка 19.09). Маленькая пилюля-чип цветами
 * чипа (`--violet-bg` / `--violet`), не заливка: это счётчик при подписи, а не орган. Не
 * сжимается и не гаснет ни на одном шаге лестницы — на 720 подпись этапа уходит, а «+3»
 * остаётся рядом с точкой: «очередь длиннее одного» — тот же вопрос на любой ширине.
 */
.more {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  padding: 0 6px;
  border-radius: var(--r-chip);
  background: var(--violet-bg);
  color: var(--accent-ink);
  font-variant-numeric: tabular-nums;
}

/* Для чтения с экрана: фраза, которую глазу заменяет «+N». */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.hide {
  background: none;
  border: none;
  padding: 2px;
  margin-left: auto;
  display: inline-flex;
  color: var(--muted);
  cursor: pointer;
  border-radius: var(--r-pill);
  flex: none;
}
.hide:hover {
  color: var(--ink);
  background: var(--bg-alt);
}

.track {
  height: 4px;
  border-radius: var(--r-pill);
  background: var(--violet-bg);
  overflow: hidden;
}

.fill {
  display: block;
  height: 100%;
  border-radius: var(--r-pill);
  background: var(--violet);
  /*
   * Ширину двигает переход, а не перерисовка: без него полоса скачет ступенями на каждом
   * ответе опроса. Длительность чуть больше шага опроса — движение читается как
   * непрерывное, а не как тик часов.
   */
  transition: width 0.4s var(--ease);
}

/* Прогон, который встал: заливка приглушается, но остаётся на своём месте — видно, докуда
   дошли, прежде чем сломалось. */
.stalled {
  background: var(--violet-light);
}

/*
 * Точка перед подписью — единственное движение в шапке. Она отвечает на вопрос, которого
 * не решает полоса: «оно ещё живо или замерло на этапе?» Дыхание медленное (1.8s) и
 * неполное (opacity не уходит в ноль) — по §8: избыточная анимация читается как «сделано
 * ИИ», и в этом интерфейсе это особенно неуместно.
 */
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--violet);
  flex: none;
  animation: breathe 1.8s var(--ease) infinite;
}

@keyframes breathe {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fill {
    transition: none;
  }
  .dot {
    animation: none;
  }
}

/* ── сжатие ────────────────────────────────────────────────────────────────── */
/*
 * Тот же порядок жертв, что и у остальной шапки (Shell.module.css): сперва уходит деталь
 * шага, потом ширина, последней — подпись этапа. Полоса не исчезает ни на одной ширине:
 * «идёт ли что-нибудь» — это то, ради чего орган существует, и на узком окне вопрос тот же.
 */
@media (max-width: 1200px) {
  .detail {
    display: none;
  }
}

/* Ступени — лестница шапки (Shell.module.css, перемерена 19.09.2026): 1599 · 1279 · 1023 · 899. */
@media (max-width: 1599px) {
  .wrap {
    width: 196px;
  }
}

@media (max-width: 1279px) {
  .wrap {
    width: 148px;
  }
}

@media (max-width: 1023px) {
  .wrap {
    width: 104px;
  }
  .label {
    font-size: 12px;
  }
}

@media (max-width: 899px) {
  /* Остаётся дорожка и дышащая точка: полный текст даёт `title` и живёт в диалоге заявки. */
  .wrap {
    width: 56px;
  }
  .label {
    display: none;
  }
}
